import {
  GET_ADMIN_USERS_SWAP_HISTORY_REQUEST,
  GET_ADMIN_USERS_SWAP_HISTORY_SUCCESS,
  GET_ADMIN_USERS_SWAP_HISTORY_FAIL,
  GET_ADMIN_SWAP_HISTORY_TOTAL_REQUEST,
  GET_ADMIN_SWAP_HISTORY_TOTAL_SUCCESS,
} from "../../actions/adminPanel/adminUsersSwapHistory";

export default function reducer(
  state = {
    history: {
      data: {
        page: 0,
        pages: 0,
        countItems: 0,
        totalOperations: 0,
        totalUsdVolume: 0,
        entities: [],
      },
      fetching: false,
    },
  },
  action
) {
  switch (action.type) {
    case GET_ADMIN_USERS_SWAP_HISTORY_REQUEST:
      return {
        ...state,
        history: {
          ...state.history,
          fetching: true
        }
      };
    case GET_ADMIN_USERS_SWAP_HISTORY_SUCCESS:
      return {
        ...state,
        history: {
          ...state.history,
          data: {
            ...state.history.data,
            ...action.payload,
          },
          fetching: false,
        },
      };
    case GET_ADMIN_USERS_SWAP_HISTORY_FAIL:
      return {
        ...state,
        history: {
          ...state.history,
          fetching: false,
        },
      };
    case GET_ADMIN_SWAP_HISTORY_TOTAL_REQUEST:
      return {
        ...state,
        totalOperations: 0,
        totalUsdVolume: 0,
      };
    case GET_ADMIN_SWAP_HISTORY_TOTAL_SUCCESS:
      return {
        ...state,
        totalOperations: action.payload.totalOperations,
        totalUsdVolume: action.payload.totalUsdVolume,
      };
    default:
      return state;
  }
}